export const getPrettyDate = function (date) {
    if(date === null) return null;
    
    let year = date.substring(0, 4);
    let month = date.substring(5, 7);
    let day = date.substring(8, 10);

    return day + "-" + month + "-" + year;
}

export const getPrettyDatetime = function (date) {
    if(date === null) return null;
    
    let year = date.substring(0, 4);
    let month = date.substring(5, 7);
    let day = date.substring(8, 10);
    let hour = date.substring(11, 13);
    let minute = date.substring(14, 16);
    let second = date.substring(17, 19);

    return day + "-" + month + "-" + year + " " + hour + ":" + minute + ":" + second;
}

export const monthDiff = function (d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

export const dayDiff = function (d1, d2) {
    let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    return Math.round(Math.abs((d2 - d1) / oneDay));
}

export const getUTCDate = function(date) {
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
}